import React, { Component} from "react";
import PropTypes from "prop-types";
import axios from "axios";
import Close from '@material-ui/icons/Close';

import './style.css'

class AutoReload extends Component {
    constructor(props) {
        super(props);
        this.previousHash = null;
        this.state = {
            codeHasChanged: false,
        };
        this.fetchSource = this.fetchSource.bind(this);
        this.closePush = this.closePush.bind(this);
    }
    componentDidMount() {
        const { tryDelay } = this.props;
        this.fetchSource();
        setInterval(this.fetchSource, tryDelay);
    }


    fetchSource() {
        return axios.get(this.props.url)
            .then(response => {
                if (response.status !== 200) {
                    throw new Error("offline");
                }

                return response
            })
            .then(response => {

                const hash = this.hash(response.data);

                if (!this.previousHash) {
                    this.previousHash = hash;
                    return;
                }
                if (this.previousHash !== hash) {
                    this.previousHash = hash;
                    this.setState({ codeHasChanged: true });
                }
            })
            .catch(() => {
                /* do nothing */
            });
    }

    hash(str) {
        const len = str.length;
        let hash = 0;
        if (len === 0) return hash;
        let i;
        for (i = 0; i < len; i++) {
            hash = (hash << 5) - hash + str.charCodeAt(i);
            hash |= 0; // Convert to 32bit integer
        }
        return hash;
    }

    reloadApp(e) {
        window.location.reload(true);
        e.preventDefault();
    }

    closePush(e) {
        this.setState({ codeHasChanged: false });
        e.stopPropagation();
    }

    render() {
        if (!this.state.codeHasChanged) return null;

        return (
            <div className='blur' >
                <button  className='refresh' onClick={this.reloadApp}>
                    <div className='close-button' onClick={this.closePush}><Close/></div>
                    <div>Candid has a new version.</div>
                    <div>Click to reload</div>
                </button>
            </div>
        );
    }
}

AutoReload.propTypes = {
    url: PropTypes.string.isRequired,
    tryDelay: PropTypes.number.isRequired,
};

AutoReload.defaultProps = {
    url: "/",
    tryDelay: 60 * 60 * 1000, // 60 minutes
};

export default AutoReload;


// WEBPACK FOOTER //
// ./src/components/Autoreload/Autoreload.jsx